import axios from "axios";
import APP_CONFIG from "../app/configuration/AppConfig";
import { IPurchasedProductsBySite } from "./Models";

export const getPurchasedProducts = async (siteIds: string[]): Promise<IPurchasedProductsBySite> => {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/purchasedProducts/getMultisite`;
  const httpResponse = await axios.post<IPurchasedProductsBySite>(url, siteIds);
  return httpResponse.data;
};
